import { ProviderModel } from "./provider.model";

export class PropertyProviderModel
{
    public id: string;
    public provider_id: string;
    public provider: ProviderModel;    
    public variance_threshold: number;
    public minimum_variance: number;
    public final_bill_adjustment: number;
    public minimum_vacant_amount: number;
    public floorplan_variance_threshold: number;
    public floorplan_minimum_variance: number;
    public service_fee_enabled: boolean = false;
}